const metricsAuthStates = {
  unauthorized: 'unauthorized',
  authorized: 'authorized',
};

export default metricsAuthStates;
